export default function floatAsStyle(f: string, defVal: string){
    let style = [];

    console.log("FFFFFFFFFFFFFFFFFFFFFF", f);

    if (f !== defVal) {
        if (f.startsWith("block-")) {

            if (f == 'block-left') {
                style.push('display: block; margin-right: auto;');
            }

            if (f == 'block-right') {
                style.push('display: block; margin-left: auto;')
            }

            if (f == 'block-center') {
                style.push('display: block; margin-left: auto; margin-right: auto;')
            }

        } else {
            style.push("display: block")
            style.push(`float: ${f}`);
        }
    }else {
        style.push("display: inline-block;vertical-align: baseline;")
    }

    return style.join(";");
}